import { variables, $ } from '../common/variables';
import { cl, ajax } from '../common/functions';

const selectInit = () => {
  const selects = document.querySelectorAll(`.bootstrap-scope select:not(.gl__type):not(#selectSecondaryType):not(#selectType)`);
  if (selects.length !== 0) {
    [...selects].forEach(select => {
      let choices = new Choices(select, variables.choicesOptions);
    });
  }
}

export { selectInit }
